import { forwardRef, useState } from 'react'

import { Box } from '@mui/material'

import { getScreenshotThumbnailUrl } from '../../helpers/implementationExampleHelpers'

type ScreenshotThumbnailProps = {
  url: string
  alt: string
  height: number
}

// Falls back to the full image when the `-800` copy is missing.
export const ScreenshotThumbnail = forwardRef<HTMLImageElement, ScreenshotThumbnailProps>(({ url, alt, height, ...props }, ref) => {
  const [failedUrl, setFailedUrl] = useState<string>()
  return (
    <Box
      {...props}
      ref={ref}
      component="img"
      src={failedUrl === url ? url : getScreenshotThumbnailUrl(url)}
      alt={alt}
      loading="lazy"
      onError={() => setFailedUrl(url)}
      sx={{ display: 'block', width: '100%', height, objectFit: 'contain', bgcolor: 'grey.100' }}
    />
  )
})

ScreenshotThumbnail.displayName = 'ScreenshotThumbnail'
